import { useRouter } from 'next/router';

function useCampaignURLHandler() {
  const router = useRouter();

  function containsCampaign(path: string) {
    return Boolean(path.match(/campaign/));
  }

  function handleCampaignAdRouterPush(path: string) {
    router.push(path);
  }

  return {
    containsCampaign,
    handleCampaignAdRouterPush,
  };
}

export { useCampaignURLHandler };
